<template>
  <div>
    <v-card-title class="headline" primary-title>
      <v-icon class="icon-title mr-2">settings</v-icon>Chart Settings
    </v-card-title>

    <v-card-text>
      <v-autocomplete
        class="select-chips"
        v-model="selectedCharts"
        :items="marketMap"
        no-data-text="No markets available..."
        itemText="user"
        label="Markets"
        name="markets"
        color="#4dbac0"
        multiple
        small-chips
        return-object
        v-on:input="limiter"
      ></v-autocomplete>
      <v-switch v-model="levels" class="ma-2" color="primary" label="Levels"></v-switch>
    </v-card-text>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  props: ["type"],
  data() {
    return {
      levels: null,
      selectedCharts: [],
      marketMap: this.$store.state.userData.markets
    };
  },
  methods: {
    limiter(e) {
      if (e.length > 4) {
        e.pop();
      }
    }
  },

  mounted() {
    this.levels = this.$store.state.userData.settings.levelsShow;
    this.selectedCharts = this.$store.state.userData.settings.submenus.Section0.items;
  },
  computed: {
    ...mapGetters(["markets"]),
  },
  watch: {
    levels(newVal, oldVal){
      if(oldVal != null){
        this.$settings("levelsShow", newVal)
      }
    },
    selectedCharts: function(val) {
      if(val.length == 0 && this.markets.length > 0){
        this.selectedCharts = this.markets.slice(-4);
      }
      this.$store
        .dispatch("API_UPDATE_SETTINGS", {
          key: "submenus.Section0.items",
          newValue: val
        })
        .then(() => {
          
        });
    }
  }
};
</script>

<style>
</style>